import { apiInterfaceForFormData, apiInterfaceForJson } from '../common/apiManager';

export const fetchClientImportTemplates = () => {
    return apiInterfaceForJson('/clientImportTemplate/v1/', 'GET');
};

export const getClientImportTemplateDataById = (clientImportTemplateId) => {
    return apiInterfaceForJson('/clientImportTemplate/v1/' + clientImportTemplateId, 'GET');
};

export const createClientImportTemplate = (clientImportTemplateDetails) => {
    return apiInterfaceForJson('/clientImportTemplate/v1/', 'POST', clientImportTemplateDetails);
};

export const updateClientImportTemplate = (clientImportTemplateDetails) => {
    return apiInterfaceForJson('/clientImportTemplate/v1/', 'PUT', clientImportTemplateDetails);
};

export const deleteClientImportTemplate = (clientImportTemplateDetails) => {
    return apiInterfaceForJson('/clientImportTemplate/v1/delete', 'POST', clientImportTemplateDetails);
};

export const uploadTemplateFile = (formData) => {
    return apiInterfaceForFormData('/clientImportTemplate/v1/uploadTemplateFile', 'POST', formData);
};
